import React from 'react'
import './Services.css'
import HeartEmoji from "../../img/heartemoji.png"
import Glasses from "../../img/glasses.png"
import Humble from "../../img/humble.png"
import Card from '../Cards/Card'
import { themeContext } from '../../Context'
import { useContext } from 'react'
function Services() {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode
  return (
    <div className="Services" id='Services'>
      {/* left side */}
      <div className="awesome">
        <span style={{color:darkMode? 'white' : ''}}>My Awesome</span>
        <span>Services</span>
        <span>Professional Front-end Developer


          
        </span>
        <button className='button s-btn'>Download CV</button>
        <div className="i-blur s-blur" style={{ background: "rgb(238 210 255)" }}> </div>
      </div>
      {/* Right Side  */}
      <div className="Cards">
        {/* Card 1 */}
        <div className="Card1">
          <Card 
          emoji={HeartEmoji} heading={'Design'} detalis={"Figma , photoshop , adobe , LightRoom ilustrater"} 
          />
        </div>
        {/* Card 2 */}
        <div className="Card2">
          <Card 
          emoji={Glasses} heading={' Front-End Developer'} detalis={"HTML CSS JAVASCRIPT FrameWork:React js"} 
          />
        </div>
        {/* Card 3 */}
        <div className="Card3">
          <Card 
          emoji={Humble} heading={'WordPress Developer'} detalis={"Cumstomiztion , E-Commerce   SEO , Speed ,Bugs "} 
          />
        </div>

      </div>

    </div>

  )
}

export default Services